// Environment check: LOCAL, STAGING, SANDBOW, PRODUCTION
export const isLocal: boolean = process.env.ENV === 'local'
export const isStaging: boolean = process.env.ENV === 'staging'
export const isSandbox: boolean = process.env.ENV === 'sandbox'
export const isTest: boolean = process.env.ENV === 'test'
export const isProduction: boolean = process.env.ENV === 'production'

// Environment check: MSW
export const isMswEnabled = process.env.MSW_API_MOCK === 'enabled'
